import React, {
  useContext,
  // useCallback,  useEffect, useState
} from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Home from "./home";
import Service from "./serviceslide/service";
import AppbarItem from "../../Component/Appbar/AppbarItem";
import Pricing from "./pricingslide/pricing";
import Document from "./documentslide/document";
import Support from "./supportslide/support";
import { LangContext } from "../../Context/Langcontext";
// import useReactRouter from "use-react-router";
// import { CheckToken, getuserbyid } from "../../API/Auth";
// import { UserContext } from "../../Context/UserContext";

const Homepage = ({ match, location }) => {
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  // const [render, setrender] = useState(false);
  // const { history } = useReactRouter();
  // const userContext = useContext(UserContext);

  React.useEffect(() => {
    document.title = `${
      location.pathname === "/home/main"
        ? lang.HOME
        : lang[String(location.pathname.replace("/home/", "")).toUpperCase()]
    } | ${lang.MEAtitle}`;
    return () => {};
  }, [location, lang]);

  // const setData = useCallback(async () => {
  //   const token = localStorage.getItem("token");
  //   if (token) {
  //     const rsCheckAuth = await CheckToken(token);
  //     if (rsCheckAuth && rsCheckAuth.token) {
  //       const user = await getuserbyid(localStorage.getItem("uid"));
  //       if (user.status.code === 200) {
  //         userContext.setstate({
  //           ...userContext.state,
  //           _id: user.data[0]._id,
  //           email: user.data[0].email,
  //           first_name: user.data[0].first_name,
  //           last_name: user.data[0].last_name,
  //           organization: user.data[0].organization,
  //           address: user.data[0].address,
  //           tambon: user.data[0].tambon,
  //           amphoe: user.data[0].amphoe,
  //           province: user.data[0].province,
  //           zipcode: user.data[0].zipcode,
  //           country: user.data[0].country,
  //           phone: user.data[0].phone,
  //           google:
  //             user.data[0].google !== undefined ? user.data[0].google : null,
  //           mea: user.data[0].mea !== undefined ? user.data[0].mea : null,
  //           facebook:
  //             user.data[0].facebook !== undefined
  //               ? user.data[0].facebook
  //               : null,
  //           contract: {
  //             start_date:
  //               user.data[0].contract === undefined
  //                 ? ""
  //                 : user.data[0].contract.start_date,
  //             end_date:
  //               user.data[0].contract === undefined
  //                 ? ""
  //                 : user.data[0].contract.end_date,
  //           },
  //           billing_info: {
  //             first_name:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.first_name,
  //             last_name:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.last_name,
  //             organization:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.organization,
  //             address:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.address,
  //             tambon:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.tambon,
  //             amphoe:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.amphoe,
  //             province:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.province,
  //             zipcode:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.zipcode,
  //             country:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.country,
  //             phone:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.phone,
  //             tax:
  //               user.data[0].billing_info === undefined
  //                 ? ""
  //                 : user.data[0].billing_info.tax,
  //           },
  //           role: user.data[0].role,
  //           created_at: user.data[0].created_at,
  //           profile_picture:
  //             user.data[0].profile_picture !== undefined
  //               ? user.data[0].profile_picture
  //               : "",
  //         });
  //       } else {
  //         localStorage.clear();
  //         history.replace(location.pathname);
  //       }
  //     } else {
  //       localStorage.clear();
  //       history.replace(location.pathname);
  //     }
  //   } else {
  //     history.replace(location.pathname);

  //     localStorage.clear();
  //   }
  // }, [history, userContext, location]);

  // useEffect(() => {
  //   if (!render) {
  //     setData();
  //     setrender(true);
  //   } else {
  //   }
  // }, [render, setData]);

  return (
    // <AppLayout>
    <AppbarItem>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/main`} />
        <Route path={`${match.url}/main`} component={Home} />
        <Route path={`${match.url}/service`} component={Service} />
        <Route path={`${match.url}/pricing`} component={Pricing} />
        <Route path={`${match.url}/document`} component={Document} />
        <Route path={`${match.url}/support`} component={Support} />

        <Redirect to="/error" />
      </Switch>
    </AppbarItem>

    // </AppLayout>
  );
};

export default Homepage;
